import queryString from 'querystring';
/**
 * Parses location string given into object with keys and values
 * @param {string} paramsStr the string containing params
 *
 * @returns {object} object with param keys and values
 */
const decodeLocation = (paramsStr = '') =>
  queryString.parse(paramsStr.slice(1));

export default decodeLocation;
